export default __webpack_public_path__ + "abf5588326f39de381fad4185fe1e81c.svg";